import { IntegrationRequestStatusBadge } from '../IntegrationRequestStatusBadge';
import DetailFields, { type DetailFieldItem } from './DetailFields';
import RequestAlerts from './RequestAlerts';
import { formatDate } from '@/utils/dates';
import DetailCard from './DetailCard';
import {
  INTEGRATION_REQUEST_TYPE_LABELS,
  type IntegrationRequestCodeRef,
  type IntegrationRequestDetail,
} from '../../../../models/IntegrationRequest';

const withCode = (ref: IntegrationRequestCodeRef | null) =>
  ref ? `${ref.name}${ref.code ? ` · código ${ref.code}` : ''}` : '-';

const buildSummaryItems = (request: IntegrationRequestDetail): DetailFieldItem[] => [
  { label: 'Comercio', value: withCode(request.commerce) },
  { label: 'Operador', value: withCode(request.logisticOperator) },
  {
    label: 'Contacto técnico',
    value: [request.contactName, request.contactEmail, request.contactPhone]
      .filter(Boolean)
      .join(' · '),
  },
  { label: 'Salida estimada', value: request.goLiveDate || '-' },
  {
    label: 'Usuario',
    value: `${request.requestedByName || '-'} · ${formatDate(request.createdAt)}`,
  },
  ...(request.handledByName
    ? [{ label: 'Último cambio de TI', value: request.handledByName }]
    : []),
  ...(request.notes ? [{ label: 'Notas', value: request.notes }] : []),
];

const RequestSummaryCard = ({ request }: { request: IntegrationRequestDetail }) => (
  <DetailCard
    title={`${INTEGRATION_REQUEST_TYPE_LABELS[request.type]} · ${request.commerce?.name ?? 'Comercio'}`}
    action={<IntegrationRequestStatusBadge status={request.status} />}
  >
    <RequestAlerts request={request} />
    <DetailFields items={buildSummaryItems(request)} />
  </DetailCard>
);

export default RequestSummaryCard;
